import angular from 'angular';

const workersServices = angular.module('applicationModule.workersServices', []);

workersServices.factory('Workers', ['WorkersAPI', 'Upload', 'AppsoupAPI', '$http', function (WorkersAPI, Upload, AppsoupAPI, $http) {
    'use strict';

    return {
        get: function (workerId, appId) {
            return WorkersAPI.getWorker(workerId, appId);
        },
        getWorkers: function (exhibitorId, appId, params) {
            return WorkersAPI.getWorkers(exhibitorId, appId, params);
        },
        save: function (data, file, editMode, exhibitorId) {
            const API_URL = AppsoupAPI.API_URL + '/app/';
            if (editMode) {
                if (angular.isDefined(file)) {
                    const newfields = angular.extend(data, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + 'worker/update/' + exhibitorId,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: newfields,
                        file: file
                    });
                } else {
                    return $http.put(API_URL + 'worker/update/' + exhibitorId, data);
                }
            } else {
                if (angular.isDefined(file)) {
                    return Upload.upload({
                        url: API_URL + 'worker/create/' + exhibitorId,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: data,
                        file: file
                    });
                } else {
                    return WorkersAPI.createWorker(data, exhibitorId);
                }
            }
        },
        edit: function (workerId) {
            return WorkersAPI.editWorker(workerId);
        },
        remove: function (workertId) {
            return WorkersAPI.removeWorker(workertId);
        }
    };
}]);

workersServices.service('WorkersAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/';

    this.createWorker = function (data, exhibitorId) {
        return $http.post(API_URL + 'worker/create/' + exhibitorId, data);
    };

    this.getWorkers = function (exhibitorId, appId, params) {
        return $http.get(API_URL + "exhibitor/" + exhibitorId + '/workers/' + appId, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getWorker = function (workerId, appId) {
        if (workerId) {
            return $http.get(API_URL + 'worker/' + workerId, {params: {application_id: appId}});
        } else {
            return $http.get(API_URL + 'worker', {params: {application_id: appId}});
        }
    };

    this.editWorker = function (workerId) {
        return $http.put(API_URL + 'worker/update/' + workerId);
    };

    this.removeWorker = function (workerId) {
        return $http.delete(API_URL + 'worker/delete/' + workerId);
    };
}]);

export default workersServices;
